export default {
  saveInfo: { id: 'save_info' },
  application: { id: 'application' },
  licensee: { id: 'licensee' },
  showInSideBarMenu: { id: 'show_in_side_bar_menu' },
  enableInUi: { id: 'enable_in_ui' },
  orderNumber: { id: 'order' },
}
